import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const unfinalizeTrialConfig = async ({ trialId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/photos/trials/${trialId}/unfinalize/`,
    {},
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useUnfinalizeTrialConfigMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: unfinalizeTrialConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["trials_list"] });
    },
  });
};

export default useUnfinalizeTrialConfigMutation;
